(function () {
    'use strict';
    angular
        .module('cog.shared')
        .controller('FillSpotDialogController', FillSpotDialogController)
        ;
    /* @ngInject */
    function FillSpotDialogController($mdDialog, triSkins, lines, getFormat, getGameLineDataObj, lineData, lineSelect, selected, accountService, BET_TYPES, customerGameSelection: ICustomerSelection, $scope, lineFormater, $window, $mdToast, appSettings, CogApiServiceProvider: ICogApiServiceProvider, PendingWagerTransformer: IPendingWagerTransformer, $rootScope, $state, pitcherFormater, 
        notificationService: INotificationService, $timeout,betModelTransformer: IBetTranformer,GameIdKeyParser) {
        var wagerLimits = (lineData != null) ? lineData.scheduleData.limits : null;
        var title = (lineData != null) ? lineData.gameNote : '';
        var lineTitle = (lineData != null) ? lineData.teamName : '';
        var line_data = (lineData != null) ? lineData.scheduleData : null;
        var fsData: IOpenBetDetail = null;
        var isBM: boolean = CogApiServiceProvider.is_BM();
        
        var confirmType_save: number = 1;
        var confirmType_continue: number = 2;
        var confirmType_cancel_leg: number = 3;
        var confirmType_cancel_bet: number = 4;
        var confirmType_accept_line: number = 5;
        var confirmType_accept_edit_line: number = 6;

        var vm = this;
        var local = { DelayUntilSignature:"", DelayUntilUTC: null, WaitHandler: null };
        vm.apiError = false;
        vm.lineData = line_data;
        //vm.showOptions = showLinesOptions();
        vm.wagerTypeTitle = getWagerTypeTitle();
        //vm.triSkin = triSkins.getCurrent();
        vm.title = title;
        vm.lineTitle = lineTitle;
        vm.cancel = cancel;
        vm.lines = lines;
        vm.getFormat = getFormat;
        vm.lineSelected = lineSelect;
        vm.limit = -1; // no limit
        vm.selected = selected;
        vm.saveBet = saveBet;
        vm.continueBet = continueBet;
        vm.cancelBet = cancelBet;
        vm.close = close;
        vm.pitcherData = pitcherData;
        vm.tp = accountService.getBetSelectionType();
        vm.isStraight = (vm.tp == BET_TYPES.S.type || vm.tp == BET_TYPES.E.type) ? true : false;
        vm.isIfbet = (vm.tp == BET_TYPES.I.type) ? true : false;
        vm.isActionReverse = (vm.tp == BET_TYPES.A.type) ? true : false;
        vm.ifbetHint = '';
        vm.legs = [];
        vm.showContinue = false;
        vm.lineTeamerTitle = '';
        vm.showLegAmount = (vm.tp == BET_TYPES.I.type) ? true : false;
        vm.showLegs = true;
        vm.fillSpotData = null;
        vm.openSpots = 0;
        vm.legsLbl = '';
        vm.currency = appSettings.currency;
        vm.currencyDecimals = appSettings.currencyDecimals;
        vm.getItemDescFillSpot = getItemDescFillSpot;
        vm.loader = false;
        vm.showCancel = false;
        vm.cancelLeg = cancelLeg;
        vm.showLegFillSpot = showLegFillSpot;
        vm.acceptLine = acceptLine;
        vm.getFormatLine = getFormatLine;
        vm.isBM = isBM;
        vm.editDetails = editDetails;
        vm.Password = "";
        vm.PasswordError = false;
        vm.allowEdit = accountService.getAllowEdit();
        vm.useFreePlay = customerGameSelection.gameSelections.GetFreePlay();
        vm.betAmount = (vm.tp == BET_TYPES.S.type || vm.tp == BET_TYPES.E.type) ? 0 : customerGameSelection.gameSelections.GetBetAmount();
        var lineDataEdited: boolean = false;

        var useLimits = (!angular.isUndefined(wagerLimits) && wagerLimits != null) ? true : false;
        activate();

        function activate() {
            fsData = customerGameSelection.openSpots.fillSpotData;
            vm.PasswordError = false;
            if(fsData.hasBetErr() && fsData.Errs.Bet.length > 0) {
                for (var i = fsData.Errs.Bet.length - 1; i >= 0; i--) {
                    if(fsData.Errs.Bet[i].Description.toLowerCase().indexOf("password") >-1){
                        fsData.Errs.Bet.splice(fsData.Errs.Bet[i], 1);
                        vm.PasswordError = true;
                    }
                }
                fsData.HasErrs = (fsData.hasBetErr() || fsData.hasItemsErr() || fsData.hasLineChangesErr()) ? true : false;
            }
            vm.fillSpotData = fsData;
            var openSpots: number = (fsData != null) ? fsData.OpenSpots : 0;
            vm.openSpots = openSpots;
            
            var strTypeBet = BET_TYPES.T.desc;

            if (vm.tp === BET_TYPES.P.type)
                strTypeBet = BET_TYPES.P.desc;
            else if (vm.tp === BET_TYPES.B.type)
                strTypeBet = BET_TYPES.B.desc;

            vm.legsLbl = (fsData != null) ? ((fsData.OpenSpots + fsData.BetItems.length).toString() + ' legs ' + strTypeBet) : "";
            processLegs();
            vm.savedBet = (vm.openSpots > 0) ? true : false;
            vm.showCancel = vm.selected;

            lineData.pitcherData.p1Selected = $("#p1_" + lineData.gameId).val() === '1' && $("#p1_" + lineData.gameId).is(":enabled") ? true : false;
            lineData.pitcherData.p2Selected = $("#p2_" + lineData.gameId).val() === '1' && $("#p2_" + lineData.gameId).is(":enabled") ? true : false;

            vm.showContinue = true;
            
        }

        $scope.range = function (n) {
            return new Array(n);
        };

        function setTeamerTitle(legs: number): void {
            vm.lineTeamerTitle = legs.toString() + "-teamer";
        }

        function processLegs() {
            vm.legs = [];
            //var legs: number = customerGameSelection.gameSelections.Items.length;
            var legs: number = customerGameSelection.openSpots.fillSpotData.OpenSpots + customerGameSelection.openSpots.fillSpotData.BetItems.length;
            setTeamerTitle(legs);
            if (legs > 0) {
                angular.forEach(customerGameSelection.gameSelections.Items, function (_lineData, idx) {
                    var leg = { linedata: _lineData.lineDetail, Amount: _lineData.Amount, pitcherData: _lineData.pitcherData, key: _lineData.Key };
                    this.push(leg);
                }, vm.legs);
            }
        }

        function showLegFillSpot(item): boolean {
            var show: boolean = true;
            var itemKey: string = item.Id;
            if (customerGameSelection.gameSelections.Items.length > 0) {
                show = ($window._.findIndex(customerGameSelection.gameSelections.Items, function (o) { return o.Key == itemKey; }) >= 0) ? false : true;
                if (show && customerGameSelection.openSpots.fillSpotData.hasLineChangesErr()) { // check for line change
                    show = ($window._.findIndex(customerGameSelection.openSpots.fillSpotData.getLineChangesErrs(), function (o) {
                        return o.Id == itemKey;
                    }) >= 0) ? false : true;
                }
            }
            return show;
        }

        function acceptLine(PreviousId) {
            var NewLineId: string = vm.fillSpotData.getLineChangeNewId(PreviousId);
            customerGameSelection.gameSelections.Swap(PreviousId, NewLineId, true);
            // actions to update schedule & gameselection data
            // update gameselection data
            var itemIdx = $window._.findIndex(customerGameSelection.gameSelections.Items, function (o) {
                return o.Key == NewLineId;
            });
            var format = "";
            if (itemIdx >= 0) {
                var formated = lineFormater.format(NewLineId);
                if (formated.Points.length > 0)
                    format = formated.Points + "<span class='txt2'>" + formated.Odds + "</span>";
                else
                    format = formated.Odds;
                customerGameSelection.gameSelections.Items[itemIdx].lineDetail.points = format;
            }
            // update dialog lineSelected data
            var _lineData: FormatedLineData = lineFormater.data(NewLineId);
            vm.lineSelected.Id = NewLineId;
            vm.lineSelected.Odds = _lineData.Odds;
            vm.lineSelected.Points = _lineData.Points;

            lineSelect.Id = NewLineId;
            lineSelect.Odds = _lineData.Odds;
            lineSelect.Points = _lineData.Points;

            // update schedule lineSetData

            processFillOpenSpot(customerGameSelection.openSpots.fillSpotData.TicketNumber, customerGameSelection.openSpots.fillSpotData.WagerNumber, confirmType_accept_line, '');
        }

        function cancelLeg(key) {
            var legId = key;
            customerGameSelection.gameSelections.Remove(legId);
            // request fillopen
            processFillOpenSpot(customerGameSelection.openSpots.fillSpotData.TicketNumber, customerGameSelection.openSpots.fillSpotData.WagerNumber, confirmType_cancel_leg, legId);
        }

        function cancel() {
            if (vm.fillSpotData.getItemErrById(vm.lineSelected.Id) == null && (vm.fillSpotData.getLineChangeErrById(vm.lineSelected.Id) != null && vm.fillSpotData.getLineChangeErrById(vm.lineSelected.Id).autoAccepted))
                $mdDialog.cancel();
            else
                cancelBet();
        }

        function getWagerTypeTitle() {
            var wagerTypeStr = "Wager";
            var betSelectionDesc = accountService.getBetSelectionDesc().toUpperCase();
            if (vm.tp == BET_TYPES.P.type || vm.tp == BET_TYPES.T.type) {
                wagerTypeStr = betSelectionDesc;
            }
            else {
                switch (vm.wagerType) {
                    case 'S':
                        wagerTypeStr = "Spread";
                        break;
                    case 'M':
                        wagerTypeStr = "Money Line";
                        break;
                    case 'T':
                        wagerTypeStr = "Total";
                        break;
                    case 'E':
                        wagerTypeStr = "Team Total";
                        break;
                }
                wagerTypeStr = betSelectionDesc + " - " + wagerTypeStr;
            }
            return wagerTypeStr;
        }

        function saveBet(confirmType: number = confirmType_save) {
            switch (vm.tp) {
                case BET_TYPES.P.type:
                case BET_TYPES.T.type:
                case BET_TYPES.B.type:
                    var gameLineData = getGameLineDataObj(lineData);
                    // add current if openspot available
                    if (vm.openSpots > 0) {
                        // swap any prev line selection
                        if (lineSelect != null)
                            customerGameSelection.gameSelections.Swap(lineSelect.Id, vm.lineSelected.Id, false);
                        // add selected line
                        var gmSelItem: IGameSelectionItem = new GameSelectionItem();
                        gmSelItem.key = vm.lineSelected.Id;
                        gmSelItem.amount = 0;
                        gmSelItem.lineDetail = gameLineData;
                        gmSelItem.period = gameLineData.scheduleData.Period;
                        gmSelItem.pitcherData = lineData.pitcherData;
                        gmSelItem.calcType = "A";

                        //customerGameSelection.gameSelections.Add(vm.lineSelected.Id, 0, gameLineData, gameLineData.scheduleData.Period, lineData.pitcherData, 'A');
                        customerGameSelection.gameSelections.Add(gmSelItem);
                    }
                    // request fillopen
                    processFillOpenSpot(customerGameSelection.openSpots.fillSpotData.TicketNumber, customerGameSelection.openSpots.fillSpotData.WagerNumber, confirmType, '');
                    break;
            }
        }

        function continueBet() {
            saveBet(confirmType_continue);
        }

        function processFillOpenSpot(TicketNumber: number, WagerNumber: number, confirmType: number, legId: string = "") {

            if (legId === void 0) { legId = ""; }
            
            vm.loader = true;
            vm.apiError = false;

            var wagers: BetSelDetail[] = customerGameSelection.gameSelections.fillSpotToWager();

            var showLateBets = accountService.getLateBets();
            var ignoreBB = accountService.getIgnoreBB();
            var autoAccept = false;
            var isPropfecta = vm.tp == BET_TYPES.B.type ? true : false;
            var openWagerData = { Save: confirmType == confirmType_continue ? true : false, Details: wagers, PasswordConfirmation: vm.Password, ShowLateBets: showLateBets, IgnoreBackBone: ignoreBB, isPropParlay: isPropfecta };

            var promiseFillOpen = (confirmType == confirmType_continue) ? CogApiServiceProvider.apiAccService().fillOpenSpotConfirm(TicketNumber, WagerNumber, openWagerData) : CogApiServiceProvider.apiAccService().fillOpenSpot(TicketNumber, WagerNumber, openWagerData);

            if (confirmType == confirmType_cancel_bet)
                promiseFillOpen = CogApiServiceProvider.apiAccService().openBetDetails(TicketNumber, WagerNumber);

            promiseFillOpen.then(function (response) {

                var openBetDtls: IOpenBetDetail = PendingWagerTransformer.transformOpenBetDetail(response);
                vm.loader = false;
                CogApiServiceProvider.setBetType(BET_TYPES[openBetDtls.BetType]);                
                openBetDtls.NeedConfirmation = vm.fillSpotData.NeedConfirmation;

                var arrChanges = openBetDtls.getLineChangesErrs();
                angular.forEach(arrChanges, function (chg, i) {
                    if (chg.AutoAccepted) {
                        customerGameSelection.gameSelections.Swap(chg.PreviousId, chg.Id, true);
                        openBetDtls.swapLineChangesErrId(chg.PreviousId, chg.Id);

                        var itemIdx = $window._.findIndex(customerGameSelection.gameSelections.Items, function (o) {
                            return o.Key == chg.Id;
                        });
                        var format = "";
                        if (itemIdx >= 0) {
                            var formated = lineFormater.format(chg.Id);
                            if (formated.Points.length > 0)
                                format = formated.Points + "<span class='txt2'>" + formated.Odds + "</span>";
                            else
                                format = formated.Odds;
                            customerGameSelection.gameSelections.Items[itemIdx].lineDetail.points = format;
                        }
                        // update dialog lineSelected data
                        var _lineData: FormatedLineData = lineFormater.data(chg.Id);
                        vm.lineSelected.Id = chg.Id;
                        vm.lineSelected.Odds = _lineData.Odds;
                        vm.lineSelected.Points = _lineData.Points;

                        lineSelect.Id = chg.Id;
                        lineSelect.Odds = _lineData.Odds;
                        lineSelect.Points = _lineData.Points;                        
                        autoAccept = true;
                    }
                });

                /*
                var openBetData: IOpenBetDetail = PendingWagerTransformer.transformOpenBetDetail(response);
                CogApiServiceProvider.setBetType(BET_TYPES[openBetData.BetType]);
                customerGameSelection.openSpots.setfillSpotData(openBetData);
                */

                if (confirmType != confirmType_accept_edit_line)
                    customerGameSelection.openSpots.setfillSpotData(openBetDtls);

                if (openBetDtls.HasErrs) {
                    vm.Password = "";
                    switch (confirmType) {
                        case confirmType_cancel_leg: // cancel leg
                            //$scope.$emit('MSG_FILLOPEN_CANCEL_LEG_EVENT', legId);
                            notificationService.notify_MSG_FILLOPEN_CANCEL_LEG_EVENT(legId);
                            // check if current is already with cancel enable to disable it
                            if (lineSelect.Id == legId)
                                vm.showCancel = false;
                            break;
                        case confirmType_cancel_bet: // cancel bet
                            var lineBetCancel = { action: 0, line: vm.lineSelected, amt: 0 };
                            if (vm.tp == BET_TYPES.P.type) {
                                lineBetCancel.line = lineSelect;
                            }
                            $mdDialog.hide(lineBetCancel);
                            break;
                        case confirmType_save:
                            var data = { id: vm.lineSelected.Id, lineBet: vm.lineSelected, selected: true };
                            //$scope.$emit('MSG_FILLOPEN_BET_SET_FAIL_EVENT', data);
                            notificationService.notify_MSG_FILLOPEN_BET_SET_FAIL_EVENT(data);
                            break;
                    }
                } else {
                    // ok
                    /*customerGameSelection.openSpots.fillSpotData = openBetDtls;
                    activate();
                    if (isBM)
                        $rootScope.$emit('MSG_BM_FILLOPEN_EVENT');
                        */
                    var confimred: boolean = false;
                    switch (confirmType) {
                        case confirmType_cancel_leg: // cancel leg
                            //$scope.$emit('MSG_FILLOPEN_CANCEL_LEG_EVENT', legId);
                            notificationService.notify_MSG_FILLOPEN_CANCEL_LEG_EVENT(legId);
                            // check if current is already with cancel enable to disable it
                            if (lineSelect.Id == legId)
                                vm.showCancel = false;
                            break;
                        case confirmType_cancel_bet: // cancel bet
                            var lineBetCancel = { action: 0, line: vm.lineSelected, amt: 0 };
                            if (vm.tp == BET_TYPES.P.type) {
                                lineBetCancel.line = lineSelect;
                            }
                            $mdDialog.hide(lineBetCancel);
                            break;
                        case confirmType_save: // bet
                            var _action = 1;
                            var lineBet = { action: _action, line: vm.lineSelected, amt: vm.bet, prevLine: lineSelect, TicketNumber: fsData.TicketNumber, WagerNumber: fsData.WagerNumber };
                            if (autoAccept && !isBM)
                                $timeout(function () {
                                    $mdDialog.hide(lineBet);
                                }, 1000);
                            else
                                $mdDialog.hide(lineBet);
                            break;
                        case confirmType_continue: // confirm
                            confimred = true;
                            if (!autoAccept) {
                                customerGameSelection.gameSelections.Clear();
                                customerGameSelection.openSpots.clearFillSpotData(true);
                            }                               
                            if (autoAccept) {
                                activate();
                                $timeout(function () {
                                    customerGameSelection.gameSelections.Clear();
                                    customerGameSelection.openSpots.clearFillSpotData(true);
                                    $mdDialog.hide();
                                    notificationService.showMessage('Wager Updated');
                                }, 1000);
                            }
                            else {
                                $timeout(function () {
                                    notificationService.showMessage('Wager Updated');
                                }, 500);
                                $mdDialog.hide();
                            }
                            var strPending = "cog.default.customer-pendingcat";
                            if (accountService.getPendingTemplate())
                                strPending = "cog.default.customer-pending";
                            if (isBM)
                                //$state.go('bm.default.customer-selstep1');
                                $state.go('bm.default.pending');
                            else
                                $state.go(strPending);                            
                            break;
                        case confirmType_accept_line:
                            notificationService.notify_MSG_BM_FILLOPEN_EVENT();
                            var _action = 1;
                            var lineBet = { action: _action, line: vm.lineSelected, amt: vm.bet, prevLine: lineSelect, TicketNumber: fsData.TicketNumber, WagerNumber: fsData.WagerNumber };
                            if (vm.openSpots > 0)
                                $mdDialog.hide(lineBet);
                            break;
                        case confirmType_accept_edit_line:
                            notificationService.notify_MSG_BM_FILLOPEN_EVENT();
                            var _action = 1;
                            var lineBet = { action: _action, line: vm.lineSelected, amt: vm.bet, prevLine: lineSelect, TicketNumber: fsData.TicketNumber, WagerNumber: fsData.WagerNumber };
                            break;
                    }
                }
                if (!confimred)
                    activate();
                if (isBM) {
                    //$rootScope.$emit('MSG_BM_FILLOPEN_EVENT');
                    notificationService.notify_MSG_BM_FILLOPEN_EVENT();
                }
                //
            },
            function () {
                vm.loader = false;
                vm.apiError = true;
            });
        }

        function cancelBet() {
            if (lineSelect != null)
                customerGameSelection.gameSelections.Remove(lineSelect.Id);
            // request fillopen
            processFillOpenSpot(customerGameSelection.openSpots.fillSpotData.TicketNumber, customerGameSelection.openSpots.fillSpotData.WagerNumber, confirmType_cancel_bet, '');
        }

        function pitcherData(lData) {
            var lineType: string;
            if (lData == null) {
                lData = lineData;
                lineType = vm.wagerType;
            }
            else {
                var formated = lineFormater.data(lData.key);
                lineType = formated.Type;
                if (lineType.length > 1)
                    lineType = lineType.slice(0, 1);
            }
            var mlbRules: IPitcherSetting = customerGameSelection.pitcherSelection.getSettings();
            var strPitchers: string = "";
            if (mlbRules != null)
                strPitchers = pitcherFormater.desc(lData.pitcherData, mlbRules, lineType, lData.scheduleData.Period, lData.scheduleData.SubSport);
            return strPitchers;
        }

        function getItemDescFillSpot(itm: BetDetail) {
            var formated = lineFormater.format(itm.Id);
            var itemDesc = '';
            itemDesc = itemDesc.concat(itm.Team).concat(' ').concat(formated.Points).concat(' ').concat(formated.Odds);
            return itemDesc;
        }

        function getFormatLine(id) {
            var formated = lineFormater.format(id);
            var format: string = "";
            if (formated.Points.length > 0)
                format = formated.Points + "&nbsp;<span class='txt2'>" + formated.Odds + "</span>";
            else
                format = formated.Odds;
            return format;
        }

        function editDetails(itmId, amt, isStraightorIfbet) {

             var lineDataEdited: string = $window._.find(vm.fillSpotData.BetItems, function (o) { return o.Id == itmId; });
            /*if (errItem != null && errItem != "undefined") {
                itm.Error.Id = "2";
                itm.Error.Description = errItem.Description;
                itm.Error.CancelOnError = errItem.ErrorType;
            }*/

            $mdDialog.show({
                controller: 'BMEditDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/core/bm/components/selstep1/bm-edit-dialog.tmpl.html',
                locals: {
                    itmId: itmId,
                    teamName: lineDataEdited.Team,
                    amount: vm.fillSpotData.Risk,
                    isStraightorIfbet: isStraightorIfbet,
                    points: lineDataEdited.Points,
                    odds: lineDataEdited.Odds
                },
                fullscreen: false,
                focusOnOpen: false,
                skipHide: true,
                clickOutsideToClose: false
            })
            .then(function (response) {
                if (response != null) {
                    var NewLineId = itmId;

                    SwapOpenSpotGame(response.Id,response.NewId,true);
                }
            });
        }

        function SwapOpenSpotGame(key, newKey, replace) {

            var idx = $window._.findIndex(customerGameSelection.openSpots.fillSpotData.BetItems, function (o) { return o.Id == key; });

            if (idx != -1) {
                var parsedKey = GameIdKeyParser.parse(newKey, true);
        
                if (parsedKey && replace) {

                    var itemIdx = $window._.findIndex(customerGameSelection.gameSelections.Items, function (o) {
                        return o.Key == key;
                    });
                    var format = "";
                    if (itemIdx >= 0) {

                        var NewLineId = replacePointsAndOdds(newKey);

                        customerGameSelection.gameSelections.Swap(key, NewLineId, true);
                        // actions to update schedule & gameselection data
                        // update gameselection data
                        var itemIdx = $window._.findIndex(customerGameSelection.gameSelections.Items, function (o) {
                            return o.Key == NewLineId;
                        });
                        var format = "";
                        if (itemIdx >= 0) {
                            var formated = lineFormater.format(NewLineId);
                            if (formated.Points.length > 0)
                                format = formated.Points + "<span class='txt2'>" + formated.Odds + "</span>";
                            else
                                format = formated.Odds;
                            customerGameSelection.gameSelections.Items[itemIdx].lineDetail.points = format;
                        }
                        // update dialog lineSelected data
                        var _lineData: FormatedLineData = lineFormater.data(NewLineId);
                        vm.lineSelected.Id = NewLineId;
                        vm.lineSelected.Odds = _lineData.Odds;
                        vm.lineSelected.Points = _lineData.Points;

                        lineSelect.Id = NewLineId;
                        lineSelect.Odds = _lineData.Odds;
                        lineSelect.Points = _lineData.Points;

                        // update schedule lineSetData
                        processFillOpenSpot(customerGameSelection.openSpots.fillSpotData.TicketNumber, customerGameSelection.openSpots.fillSpotData.WagerNumber, confirmType_accept_edit_line, '');
                        
                    }

                }
            }
        }

        function replacePointsAndOdds(idKey) {
            if (!idKey) {
                return null;
            }

            try {
                var arr = idKey.split('_');
                
                if (arr.length >= 9) {
                    var overridePoints = arr[7];
                    var overrideOdds = arr[8];
                    
                    arr[2] = overridePoints;
                    arr[3] = overrideOdds;
                    
                    return arr.slice(0, 7).join('_');
                }
                
                // Si no tiene override, retornar el original
                return idKey;
                
            } catch (error) {
                console.error('Error replacing points and odds:', error);
                return null;
            }
        }

        function close() {
            $mdDialog.hide();
        }

    }
})();
